module.exports = "data:image/gif;base64,R0lGODdhBwBCALMAALmzsMC9uMnHxcnHxcnHxc/W2tbRzNnW0eTh3wAAAAAAeQAAAAAAAAALAAAACwAAACH5BAEAAAkALAAAAAAHAEIAAAQ+MMlJq7046wS6B0UoFkhpnucoCmwrbHAsz3Q9Cx8gBGpgoD7UTpVwsWzIpHIJyxkSPQHKEEAdeKOA8cjsZiIAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/slider/slider-bg.gif
 ** module id = 498
 ** module chunks = 0
 **/